import { ModalDialog, Mtds } from 'prove-common'
import { useId } from 'react'

type ConfirmActivatePlanModalProps = {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  missingApprovalCount: number
}

export const ConfirmActivatePlanModal = ({
  open,
  onClose,
  onConfirm,
  missingApprovalCount
}: ConfirmActivatePlanModalProps) => {
  const id = useId()
  const modalId = `confirm-activate-plan-modal-${id}`

  return (
    <ModalDialog id={modalId} closedby='any' open={open} onClose={onClose}>
      <Mtds.Button command='close' commandfor={modalId} aria-label='Lukk' />
      <Mtds.Prose>
        <Mtds.Heading>Bekreft aktivering</Mtds.Heading>
        <p>
          {`Planen har ${missingApprovalCount} ${missingApprovalCount === 1 ? 'oppgave' : 'oppgaver'} som ikke er godkjent fra lab. Oppgavene vil ikke vises i Prøveta før de blir godkjent.`}
        </p>
        <Mtds.Flex style={{ paddingTop: 'var(--mtds-8)' }}>
          <Mtds.Button command='close' commandfor={modalId}>
            Avbryt
          </Mtds.Button>
          <Mtds.Button data-variant='primary' onClick={onConfirm}>
            Aktiver plan
          </Mtds.Button>
        </Mtds.Flex>
      </Mtds.Prose>
    </ModalDialog>
  )
}
